
<script setup>
import { ref, computed, onBeforeUnmount } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useEcusStore } from '@/stores/ecus'
import { useEcusDiagStore } from '@/stores/ecus-diag'
// import Modal from '@/components/UTAModal.vue'
import errorFlagNames from '@/helpers/errorFlagNames'
import UTAError404 from '@/components/UTAError404.vue'

// function changePage(cursor, dir) {

//     const params = {
//         uuid_car_array: props.uuid,
//         names: props.ecuName,
//         'c.limit': 6,
//         'c.direction': dir, 
//         'c.cursor': cursor
//     }

//     ecusDiagStore.readReports(params).then(result => {
//         if(result.array) {
//             dir == 'after' ? 
//                 pageNumber.value++ : 
//                 pageNumber.value--
//         }
//     })
// }

function tabs(event) {

    const tabsElements = event.target.parentNode.parentNode.childNodes

    for(let tabsBlock of tabsElements) {

        if(tabsBlock.classList.contains('tabs__control')) {
            for(let link of tabsBlock.childNodes) {
                link.classList.remove('tabs__link--active')
            }
            event.target.classList.add('tabs__link--active')
        } 

        if(tabsBlock.classList.contains('tabs__body')) {
            for(let tab of tabsBlock.childNodes) {
                if(tab.id) {
                    if(tab.id == event.target.dataset.target) {
                        if(!tab.classList.contains('tabs__tab--active')) {
                            tab.classList.add('tabs__tab--active')
                        }
                    } else {
                        tab.classList.remove('tabs__tab--active')
                    }
                }
            }
        }
    }
}

// function fetchEcuHistory () {

//     showEcuHistory.value = true
//     pageNumber.value = 1

//     let data = {
//         uuid_car_array: props.uuid,
//         names: props.ecuName,
//         'c.limit': 6
//     }

//     ecusDiagStore.readReports(data)
// }

const props = defineProps({
    ecuName: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore   = useTranslaterStore()
const ecusStore         = useEcusStore()
const ecusDiagStore     = useEcusDiagStore()

const getTranslate          = computed(() => translaterStore.getTranslate)
const ecus                  = computed(() => ecusStore.ecus)
// const reports               = computed(() => ecusDiagStore.reports)
// const reportsProcess        = computed(() => ecusDiagStore.reportsProcess)
// const reportsMsg            = computed(() => ecusDiagStore.reportsMsg)
const diagRunProcess        = computed(() => ecusDiagStore.diagRunProcess)
const diagRunMsg            = computed(() => ecusDiagStore.diagRunMsg)
const diagDeleteDTCProcess  = computed(() => ecusDiagStore.diagDeleteDTCProcess)
const diagDeleteDTCMsg      = computed(() => ecusDiagStore.diagDeleteDTCMsg)

const ecu = computed(() => ecus.value[props.ecuName])

const errors = computed(() => {
    if(ecu.value.report.status !== null) {
        return errorsOnlyActive.value ?
            ecu.value.report.val.filter( error => error.flags.TF === 1) :
            ecu.value.report.val
    }
    return []
})

// сортировка ошибок по tF === 1 - ключ, показывающий активную ошибку
const errorsSorted  = computed(() => [...errors.value].sort((prev, cur) => cur.flags.TF - prev.flags.TF))

const errorsOnlyActive = ref(false)
// const showEcuHistory = ref(false)
// const pageNumber = ref(1)

onBeforeUnmount(() => {

    ecusDiagStore.setDiagRunMsg({})
    ecusDiagStore.setDiagDeleteDTCMsg({})
})
</script>

<template>

    <div v-if="ecu" class="uta-ecus-ecu">

        <header class="uta-header" role="heading" aria-level="1">
            <h1 class="uta-header__title">
                {{ ecu.info.name }} 
                <span class="uta-header__subtitle">{{ ecu.info.fullName }}</span>
            </h1>
            <div class="uta-header__actions">
                <button 
                    class="uta-btn uta-btn--sm uta-btn--has-icon uta-header__action uta-header__action--create"
                    :disabled="diagRunProcess"
                    @click="ecusDiagStore.runDiag({ 
                        uuid: props.uuid, 
                        diag: {
                            ecu: props.ecuName + '_UAZ'
                        }
                    })"
                >
                    <span class="uta-btn__content">
                        <span class="uta-btn__icon material-icons">
                            refresh
                        </span>
                        <span class="uta-btn__text uta-btn__text--has-icon d-none d-md-block">
                            {{ getTranslate.ECU_GNSS_REFRESH }}
                        </span>
                    </span>
                </button>
            </div>
        </header>

        <div class="page__content">

            <div 
                v-if="'success' in diagRunMsg"
                class="mb-4 uta-alert uta-ecus-ecu__message"
                :class="{
                    'uta-alert--success': diagRunMsg.success,
                    'uta-alert--danger': !diagRunMsg.success
                }"
            >
                <div class="material-icons uta-alert__icon">
                    {{ diagRunMsg.success ? 'check_circle_outline' : 'error_outline' }}
                </div>
                <div class="uta-alert__text">
                    {{ getTranslate[diagRunMsg.text] || diagRunMsg.text }}
                </div>
                <button type="button" class="uta-alert__close" @click="ecusDiagStore.setDiagRunMsg({})">
                    <span class="material-icons">close</span>
                </button>
            </div>

            <div class="tabs mb-4">
                <div class="uta-ecus-ecu__tabs tabs__control">
                    <div class="uta-ecus-ecu__tab tabs__link tabs__link--active" data-target="carEcuParams" @click="tabs($event)">
                        {{ getTranslate.ECU_REPORTS }}
                    </div>
                    <div class="uta-ecus-ecu__tab tabs__link" data-target="carEcuErrors" @click="tabs($event)">
                        {{ getTranslate.ECU_ERRORS }} <span class="tabs__link-icon" v-if="ecu.report.val.length"></span>
                    </div>
                </div>
                <div class="tabs__body">
                    <div class="uta-ecus-ecu__info tabs__tab tabs__tab--active mt-4" id="carEcuParams">
                        <div class="uta-ecus-ecu__dids">
                            <div class="uta-ecus-ecu__did-timestamp my-4">
                                {{ getTranslate.ECU_TIMESTAMP }}: {{ ecu.info.timeStamp ? new Date(ecu.info.timeStamp * 1000).toLocaleString() : '–' }}
                            </div>
                            <!-- <div class="uta-ecus-ecu__did-mileage my-4">
                                {{ getTranslate.STATE_TOTAL_MILEAGE }}: {{ ecu.info.mileage ? ecu.info.mileage + ' ' + getTranslate.UNIT_KM : '–' }}
                            </div> -->
                            <template v-if="'did' in ecu.report && ecu.report.did.length">
                                <div class="uta-ecus-ecu__did" v-for="(did, index) in ecu.report.did" :key="index">
                                    <div class="row">
                                        <div class="col">
                                            <div class="">
                                                <div class="row">
                                                    <div class="col-3 col-md-3 col-lg-2">
                                                        <div class="uta-ecus-ecu__did-did">
                                                            {{ did.did }}
                                                        </div>
                                                    </div>
                                                    <div class="col-9 col-md-9 col-lg-5">
                                                        <div class="uta-ecus-ecu__did-name">
                                                            {{ did.name }}
                                                        </div>
                                                    </div>
                                                    <div class="mt-3 mt-md-0 col-12 col-lg-5">
                                                        <div class="uta-ecus-ecu__did-value">
                                                            <template v-if="did.response == 'false'">
                                                                <span class="uta-ecus-ecu__did-value-fail">No positive response</span>
                                                            </template>
                                                            <template v-else-if="did.response == 'true' && did.value == null">
                                                                <div class="uta-ecus-ecu__did-value-epicfail">Data parsing error</div>
                                                            </template>
                                                            <template v-else>
                                                                {{ did.value }}
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                {{ getTranslate.ECU_PARAMS_NO_INFO }}
                            </template>
                        </div>
                    </div>

                    <div class="uta-ecus-ecu__errors tabs__tab mt-4" id="carEcuErrors">
                        <div class="mb-4 switcher uta-ecus-ecu__errors-filter">
                            <input class="switcher__input uta-ecus-ecu__errors-filter-input" type="checkbox" id="ADTEcuFilter" v-model="errorsOnlyActive" :checked="errorsOnlyActive">
                            <label class="switcher__label uta-ecus-ecu__errors-filter-label" for="ADTEcuFilter">
                                <span class="switcher__text">{{ getTranslate.ECU_ERRORS_ONLY_ACTIVE }}</span>
                            </label>
                        </div>
                        <template v-if="errorsSorted.length">
                            <div id="ecuAccordion">
                                <div
                                    v-for="(error, index) in errorsSorted" 
                                    :key="error.code"
                                    class="uta-ecus-ecu__errors-item"
                                    :class="{ 'uta-ecus-ecu__errors-item--active' : error.flags.TF === 1 }"
                                >
                                    <div 
                                        class="collapsed uta-ecus-ecu__errors-item-header collapsed"
                                        :id="'ecuAccordion_collapse_' + index"
                                        data-bs-toggle="collapse" 
                                        :data-bs-target="'#collapse' + index" 
                                        aria-expanded="false" 
                                        :aria-controls="'collapse' + index"
                                    >
                                        <div class="row uta-ecus-ecu__errors-item-body">
                                            <div class="col-10 col-lg-11">
                                                <div class="uta-ecus-ecu__errors-item-title">{{ error.value }}</div>
                                            </div>
                                            <div class="col-10 col-lg-11">
                                                <div class="uta-ecus-ecu__errors-item-value">{{ error.longName }}</div>
                                            </div>
                                            <span class="material-icons">
                                                expand_less
                                            </span>
                                        </div>
                                    </div>
                                    <div 
                                        :id="'collapse' + index" 
                                        class="collapse" 
                                        :aria-labelledby="'ecuAccordion_collapse_' + index" 
                                        data-bs-parent="#ecuAccordion"
                                    >
                                        <div
                                            v-for="(value, name, index) in error.flags"
                                            :key="name"
                                            class="uta-ecus-ecu__errors-subitem" :class="{ 'uta-ecus-ecu__errors-subitem--grey' : index % 2 === 0 }"
                                        >
                                            <div class="row">
                                                <div class="col-10 col-md-5">
                                                    {{ errorFlagNames[name]['title'] }}
                                                </div>
                                                <div class="col-2 text-end text-md-start">
                                                    {{ value }}
                                                </div>
                                                <div class="col-12 col-md-5">
                                                    {{ errorFlagNames[name][value] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div 
                                v-if="'success' in diagDeleteDTCMsg"
                                class="my-4 uta-alert uta-ecus-ecu__message"
                                :class="{
                                    'uta-alert--success': diagDeleteDTCMsg.success,
                                    'uta-alert--danger': !diagDeleteDTCMsg.success
                                }"
                            >
                                <span class="material-icons alert__icon">
                                    {{ 
                                        diagDeleteDTCMsg.success ? 
                                            'check_circle_outline' : 
                                            'error_outline' 
                                    }}
                                </span>
                                <span class="alert__text">{{ diagDeleteDTCMsg.text }}</span>
                                <button type="button" class="btn-close uta-alert__close" @click="ecusDiagStore.setDiagDeleteDTCMsg({})">
                                    <span class="material-icons">close</span>
                                </button>
                            </div>

                            <div class="uta-btns my-4">
                                <button
                                    href="#" 
                                    class="uta-btn btn--icon"
                                    :disabled="diagDeleteDTCProcess"
                                    @click="ecusDiagStore.deleteDiagDTC({ 
                                        uuid: props.uuid, 
                                        clear: { ecu: props.ecuName + '_UAZ' }
                                    })"
                                >
                                    <div class="uta-btn__content">
                                        <span class="material-icons">
                                            delete
                                        </span>
                                        <div class="uta-btn__text uta-btn__text--has-icon">
                                            {{ getTranslate.ECUS_DIAG_CLEAR_DTC }}
                                        </div>
                                    </div>
                                </button>
                            </div>

                        </template>

                        <template v-else>
                            <template v-if="ecu.report.status == null && ecu.installed">
                                <span :style="{'color': '#FF0000'}">No positive response</span>
                            </template>
                            <template v-else>
                                {{ getTranslate.ECU_ERRORS_EMPTY }}
                            </template>
                        </template>

                    </div>
                </div>
            </div>
        </div>

        <!-- <hr> -->

        <!-- <button class="uta-btn" @click="fetchEcuHistory">{{ getTranslate.ECU_HISTORY }}</button> -->
<!-- 
        <transition name="bounce">
            <Modal 
                v-if="showEcuHistory"
                :header="getTranslate.ECU_HISTORY"
                size="lg"
                @closeModal="
                    showEcuHistory = false, 
                    ecusDiagStore.setReportsMsg({}), 
                    ecusDiagStore.setReports({})
                "
            >
                <template v-slot:body>
                    <div class="loader loader--modal-lg" v-if="reportsProcess && !reports?.array?.length">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div 
                        class="uta-alert uta-alert--danger uta-carinfo__message"
                        v-if="reportsMsg.text && !reportsMsg.success"
                    >
                        <div class="uta-alert__icon">
                            <span class="material-icons">
                                error_outline
                            </span>
                        </div>
                        <div class="uta-alert__text">{{ getTranslate[reportsMsg.text] || reportsMsg.text }}</div>
                    </div>
                    <div class="mt-4" v-if="reports?.array?.length">
                        <div class="list">
                            <div class="uta-list__title d-none d-md-block">
                                <div class="row">
                                    <div class="col-md-9">{{ getTranslate.ECU_FILE }}</div>
                                </div>
                            </div>
                            <div class="uta-list__content">
                                <div 
                                    class="row align-items-center uta-list__item" 
                                    :class="{ 'uta-list__item--dark' : index % 2 }" 
                                    v-for="(item, index) in reports.array" 
                                    :key="item.createdAt"
                                >
                                    <div class="col-4">
                                       {{ item.name }}
                                    </div>
                                    <div class="col-4">
                                        {{ new Date(Number(item.tm) * 1000).toLocaleString() }}
                                    </div>
                                    <div class="col-4">
                                        <button class="uta-btn uta-btn--block">{{ getTranslate.ECU_REMOVE }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uta-cars__pagination" v-if="reports.c && (reports.c.isBefore || reports.c.isAfter)">
                        <div class="row">
                            <div class="col-12 col-xs-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2">
                                <div class="uta-pagination">
                                    <button 
                                        :disabled="reportsProcess || !reports.c.isBefore"
                                        class="uta-btn uta-btn--sm uta-pagination__prev" 
                                        @click.prevent="changePage(reports.c.start, 'before')"
                                    >
                                        <span class="material-icons">
                                            navigate_before
                                        </span>
                                    </button>
                                    <div class="uta-pagination__current">
                                        {{ pageNumber }}
                                    </div>
                                    <button 
                                        :disabled="reportsProcess || !reports.c.isAfter"
                                        class="uta-btn uta-btn--sm uta-pagination__next" 
                                        @click.prevent="changePage(reports.c.stop, 'after')"
                                    >
                                        <span class="material-icons">
                                            navigate_next
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Modal>
        </transition> -->

    </div>
    <UTAError404 v-else />
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/ecus/ecus-ecu.scss';
</style>